<!-- No facility bar: these figures span every facility the user is associated with, so naming the
     one selected in the header would misdescribe them. Each row names its own facility instead. -->
<pcg-resizable-widget>
    <span widget-title>Insulin Queue Summary</span>

    <div class="h-100" widget-body>
        @if (isLoading()) {
            <div class="mt-2 pb-1 text-center" aria-live="polite">
                <span class="spinner-border spinner-border-sm align-middle mr-1" aria-hidden="true"></span>
                Loading Insulin queue counts...
            </div>
        } @else if (hasError()) {
            <!-- Three zeroes would read as "nothing to do", which is the one wrong thing to tell
                 somebody whose figures failed to load. -->
            <div class="insulin-widget-state text-danger" role="alert">
                <i class="pi pi-exclamation-triangle mr-1" aria-hidden="true"></i>
                These counts could not be loaded. Refresh to try again.
            </div>
        } @else if (!isEnabled()) {
            <div class="insulin-widget-state">
                {{ unavailableMessage() }}
            </div>
        } @else {
            <!-- A list, because that is what three labelled figures are. The visual arrangement is
                 the stylesheet's business; the reading order is the same either way. -->
            <ul class="insulin-card-grid">
                @for (card of cards(); track card.label) {
                    <li class="insulin-card" [attr.data-severity]="card.severity">
                        <!-- The whole card is the link: the figure is the thing being clicked, and
                             the destination rechecks authorization for every row it then shows. -->
                        <pcg-link [href]="card.href" [hideStyling]="true">
                            <!-- The padding is on this, inside the link, so the link fills the card
                                 edge to edge; on the card it left a margin that did not click. -->
                            <div class="insulin-card-body">
                                <div class="insulin-card-label">{{ card.label }}</div>
                                <div class="insulin-card-value">{{ card.count }}</div>
                                @if (card.sub) {
                                    <div class="insulin-card-sub">{{ card.sub }}</div>
                                }
                            </div>
                        </pcg-link>
                    </li>
                }
            </ul>
        }
    </div>
</pcg-resizable-widget>
